import { useEffect, useState } from 'react';
import { Translate } from '~/i18n';
import { ActiveStar, DefaultStar } from '~/svgs/review';

export const feedback = [
   <div key={0} className="text-gray-400">
      <Translate id="review:select rate" />
   </div>,
   <Translate key={1} id="review:very poor" />,
   <Translate key={2} id="review:bad" />,
   <Translate key={3} id="review:ok" />,
   <Translate key={4} id="review:good" />,
   <Translate key={5} id="review:great" />,
];

type RatingStarsProps = {
   title: React.ReactNode;
   // eslint-disable-next-line no-unused-vars
   onChange: (value: number) => any;
   submitted: boolean;
};

export const RatingStars = ({ title, onChange, submitted }: RatingStarsProps) => {
   const [rating, setRating] = useState<number>(0);
   const [ratingHover, setRatingHover] = useState(0);
   const [checked, setChecked] = useState(false);

   useEffect(() => {
      onChange?.(rating);
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [rating]);

   return (
      <div>
         {title}
         <div className="flex mt-4 box">
            {[0, 1, 2, 3, 4].map((index, key) => {
               const ratingvalue = index + 1;
               return (
                  <label key={key}>
                     <input
                        id="experience_rating"
                        className="hidden"
                        type="radio"
                        name="experience_rating"
                        value={rating}
                        onClick={() => setRating(ratingvalue)}
                        onChange={() => setChecked(true)}
                     />
                     <div
                        className="p-1 xs:p-2 "
                        onMouseEnter={() => setRatingHover(ratingvalue)}
                        onMouseLeave={() => setRatingHover(0)}>
                        {ratingvalue <= (ratingHover || rating) ? <DefaultStar /> : <ActiveStar />}
                     </div>
                  </label>
               );
            })}
            <div className="p-2 small:pt-3 pt-1.5 text-xs xs:text-sm ">
               {!checked && submitted ? (
                  <div className="text-red-600">
                     <Translate id="business:required field" />
                  </div>
               ) : (
                  <div>{feedback[ratingHover || rating]}</div>
               )}
            </div>
         </div>
      </div>
   );
};
